export { VerticalNavigationComponent } from './vertical-navigation.component';
export { VerticalNavigationModule } from './vertical-navigation.module';
